module.exports = __webpack_public_path__ + "img/Girl_030035.4d248278.png";